import { ButtonBase } from "@mui/material";

interface Props {
  label: string;
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const IconTile = ({ label, selected, onClick, children }: Props) => (
  <ButtonBase
    aria-label={label}
    aria-pressed={selected}
    onClick={onClick}
    sx={{
      width: "30px",
      height: "30px",
      borderRadius: 1,
      border: 1,
      borderColor: selected ? "primary.main" : "transparent",
      bgcolor: selected ? "action.hover" : undefined,
      color: selected ? "primary.main" : "action.active",
    }}
  >
    {children}
  </ButtonBase>
);

export default IconTile;
